<template>
  <div rel="textExample">
    <div>
      <h3>文本格式要求</h3>
      <ol>
        <li>1.矩阵题等需要加入题型标记才能正常识别</li>
        <li>2.题目与题目之间加入空行分割</li>
        <li>3.请使用英文符号，中文符号无法识别</li>
      </ol>
      <h3>格式说明</h3>
      <ul>
        <li>1.题型符号：[标题]</li>
        <li>2.题目备注：(题目备注)</li>
        <li>3.分页符号：====分页====</li>
      </ul>
      <h3>单选题型说明</h3>
      <div class="example">
        <div class="source">
          <span>您使用什么系统的手机？[单选题]</span>
          <ul>
            <li v-for="(item, idx) in radioOptions" :key="idx">{{item.label}}</li>
          </ul>
        </div>
        <div class="dist radio-options">
          <span>您使用什么系统的手机？</span>
          <el-radio-group>
            <el-radio
              v-for="(item, index) in radioOptions"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-radio>
          </el-radio-group>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>多选题型说明</h3>
      <div class="example">
        <div class="source">
          <span>您使用什么系统的手机？[多选题]</span>
          <ul>
            <li v-for="(item, index) in checkboxOptions" :key="index">{{item.label}}</li>
          </ul>
        </div>
        <div class="dist">
          <span>您使用什么系统的手机？</span>
          <el-checkbox-group>
            <el-checkbox
              v-for="(item, index) in checkboxOptions"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>下拉题型说明</h3>
      <div class="example">
        <div class="source">
          <span>您使用什么系统的手机？[下拉题]</span>
          <ul>
            <li v-for="(item, index) in checkboxOptions" :key="index">{{item.label}}</li>
          </ul>
        </div>
        <div class="dist">
          <span>您使用什么系统的手机？</span>
          <el-select size="small" v-model="selectValue">
            <el-option
              v-for="(item, idx) in checkboxOptions"
              :label="item.label"
              :value="item.value"
              :key="idx"
            ></el-option>
          </el-select>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>文本题型说明</h3>
      <div class="example">
        <div class="source">
          <span>评价原生Android手机系统？[文本题]</span>
          <ul>
            <li v-for="(item, index) in radioOptions" :key="index">{{item.label}}</li>
          </ul>
        </div>
        <div class="dist">
          <span>评价原生Android手机系统?</span>
          <el-input type="textarea"></el-input>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>矩阵单选题型说明</h3>
      <div class="example">
        <div class="source">
          <span>评价原生Android手机系统？[矩阵单选题]</span>
          <ul>
            <li v-for="(item, index) in matrixRadioOptions" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="dist">
          <span>评价原生Android手机系统？</span>
          <table>
            <tr>
              <td></td>
              <td>很好</td>
              <td>一般</td>
              <td>很差</td>
            </tr>
            <tr>
              <td>美观性</td>
              <td>
                <el-radio label></el-radio>
              </td>
              <td>
                <el-radio label></el-radio>
              </td>
              <td>
                <el-radio label></el-radio>
              </td>
            </tr>
            <tr>
              <td>实用性</td>
              <td>
                <el-radio label></el-radio>
              </td>
              <td>
                <el-radio label></el-radio>
              </td>
              <td>
                <el-radio label></el-radio>
              </td>
            </tr>
          </table>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>矩阵多选题型说明</h3>
      <div class="example">
        <div class="source">
          <span>评价原生Android手机系统？[矩阵多选题]</span>
          <ul>
            <li v-for="(item, index) in matrixRadioOptions" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="dist">
          <span>评价原生Android手机系统？</span>
          <table>
            <tr>
              <td></td>
              <td>很好</td>
              <td>一般</td>
              <td>很差</td>
            </tr>
            <tr>
              <td>美观性</td>
              <td>
                <el-checkbox label></el-checkbox>
              </td>
              <td>
                <el-checkbox label></el-checkbox>
              </td>
              <td>
                <el-checkbox label></el-checkbox>
              </td>
            </tr>
            <tr>
              <td>实用性</td>
              <td>
                <el-checkbox label></el-checkbox>
              </td>
              <td>
                <el-checkbox label></el-checkbox>
              </td>
              <td>
                <el-checkbox label></el-checkbox>
              </td>
            </tr>
          </table>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>矩阵打分题型说明</h3>
      <div class="example">
        <div class="source">
          <span>评价原生Android手机系统？[矩阵打分题]</span>
          <ul>
            <li v-for="(item, index) in matrixStarOptions" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="dist">
          <span>评价原生Android手机系统？</span>
          <p>
            <span class="matrixStar-p">非常不满意</span>
            <span class="matrixStar-p">非常满意</span>
          </p>
          <p>
            <el-col :span="6">美观性</el-col>
            <el-col :span="14">
              <el-slider :step="1" :min="1" :max="5" show-stops></el-slider>
            </el-col>
          </p>
          <p>
            <el-col :span="6">实用性</el-col>
            <el-col :span="14">
              <el-slider :step="1" :min="1" :max="5" show-stops></el-slider>
            </el-col>
          </p>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>打分题型说明</h3>
      <div class="example">
        <div class="source">
          <span>评价原生Android手机系统？[打分题]</span>
          <ul>
            <li>1~5</li>
          </ul>
        </div>
        <div class="dist">
          <span>评价原生Android手机系统？</span>
          <ul>
            <li>
              (非常不满意)
              <el-radio label="1"></el-radio>
              <el-radio label="2"></el-radio>
              <el-radio label="3"></el-radio>
              <el-radio label="4"></el-radio>
              <el-radio label="5"></el-radio>(非常满意)
            </li>
          </ul>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>排序题型说明</h3>
      <div class="example">
        <div class="source sort">
          <span>您在各类app（手机软件）上的所花费的时间比重，由大到小排序是？[排序题](请将全部选项进行排序)</span>
          <ul>
            <li v-for="(item, index) in sortOptions" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="dist sort">
          <span>您在各类app（手机软件）上的所花费的时间比重，由大到小排序是？</span>
          <p class="desc">请将全部选项进行排序</p>
          <el-input
            v-for="(option, index) in sortOptions"
            class="option-item"
            v-html="option"
            :key="index"
            :readonly="true"
          ></el-input>
        </div>
        <div class="arrow arr-sort">→</div>
      </div>
      <h3>联动题型说明</h3>
      <div class="example">
        <div class="source chained">
          <span>您使用的手机型号是？[联动题](题目备注)</span>
          <ul>
            <li v-for="(item, index) in chainedOptions" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="dist chained">
          <span>您使用的手机型号是？</span>
          <p class="chained-show">
            <span>品牌</span>
            <el-select size="mini" v-model="selectValue">
              <el-option label="苹果" value="apple"></el-option>
              <el-option label="三星" value="galaxy"></el-option>
            </el-select>
          </p>
        </div>
        <div class="arrow arr-chained">→</div>
      </div>
      <h3>附件题型说明</h3>
      <div class="example">
        <div class="source upload">
          <span>请上传您的简历？[附件题]</span>
        </div>
        <div class="dist upload">
          <span>请上传您的简历?</span>
          <p class="file alignCenter">
            点击
            <span class="addFile">添加文件</span>或将文件拖至此处
          </p>
          <p class="alignCenter">文件大小限制:5MB</p>
        </div>
        <div class="arrow">→</div>
      </div>
      <h3>段落说明题型说明</h3>
      <div class="example">
        <div class="source description">
          <ul>
            <li>第一部分 基本信息[段落说明]</li>
          </ul>
        </div>
        <div class="dist description">
          <ul>
            <li>第一部分 基本信息</li>
          </ul>
        </div>
        <div class="arrow arr-description">→</div>
      </div>
      <h3>填空题型说明</h3>
      <div class="example">
        <div class="source description">
          <ul>
            <li>姓名:____; 性别:____; [填空题]</li>
          </ul>
        </div>
        <div class="dist description">
          <ul>
            <li>姓名:____; 性别:____;</li>
          </ul>
        </div>
        <div class="arrow arr-description">→</div>
      </div>
    </div>
  </div>
</template>
<script>
let options = [
  {
    label: "A.IOS",
    value: "A"
  },
  {
    label: "B.Android",
    vlaue: "B"
  },
  {
    label: "C.Windows Phone",
    value: "C"
  }
];
export default {
  name: "textExample",
  data() {
    return {
      radioOptions: [...options],
      checkboxOptions: [...options, { label: "D.其他", value: "D" }],
      matrixRadioOptions: ["很好 一般 很差", "美观性", "实用性"],
      sortOptions: [
        "社交类",
        "游戏类",
        "资讯类",
        "工具类",
        "娱乐类",
        "金融类",
        "教育类"
      ],
      matrixStarOptions: ["1~3", "美观性", "实用性"],
      chainedOptions: [
        "品牌 型号",
        "苹果",
        "+iPhone5",
        "+iPhone6",
        "三星",
        "+Galaxy S5",
        "+Galaxy S6"
      ],
      selectValue: ""
    };
  }
};
</script>
<style lang="scss">
div[rel="textExample"] {
  width: 760px;
  ol,
  ul {
    display: block;
    list-style-type: decimal;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 12px;
  }
  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
  .source,
  .dist {
    font-size: 15px;
    vertical-align: top;
    display: inline-block;
    background: #f0f0f0;
    border: 1px solid #ddd;
    width: 340px;
    height: 180px;
    line-height: 180%;
    padding: 20px;
    color: #333;
    margin: 20px 0px;
  }
  .desc {
    color: #999;
  }
  .sort {
    height: 310px;
  }
  .upload {
    height: 150px;
  }
  .description {
    height: 100px;
  }
  .chained {
    height: 270px;
  }
  .dist {
    margin-left: 30px;
    .file {
      padding-top: 20px;
      .addFile {
        color: #ff552e;
      }
    }
    .matrixStar-p {
      padding-left: 50px;
    }
  }
  .radio-options .el-radio,
  .el-checkbox {
    width: 100%;
    height: 27px;
  }
  .el-radio-group .el-radio:first-child {
    margin-top: 20px;
  }
  .radio-options .el-radio + .el-radio,
  .el-checkbox + .el-checkbox {
    margin-left: 0px;
  }
  .arrow {
    color: #58a6e7;
    font-size: 30px;
    position: absolute;
    top: 92px;
    left: 342px;
  }
  .arr-description {
    top: 60px;
  }
  .arr-sort {
    top: 170px;
  }
  .arr-chained {
    top: 140px;
  }
  .example {
    position: relative;
  }
  .dist td {
    text-align: center;
    padding: 0 15px 0 0;
  }
  .alignCenter {
    text-align: center;
  }
  .chained-show {
    margin-top: 20px;
  }
  .option-item {
    width: 250px;
    margin-bottom: 1px;
    border: 1px solid #ddd;
    background: #fff;
    .el-input__inner {
      cursor: move;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/textExample.vue